"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sections = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _shared = require("@lachevaliniere/shared");

var _sectionsModule = _interopRequireDefault(require("./sections.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Sections = function Sections(_ref) {
  var sections = _ref.sections,
      pages = _ref.pages,
      props = _objectWithoutProperties(_ref, ["sections", "pages"]);

  return /*#__PURE__*/_react.default.createElement(_shared.Section, props, /*#__PURE__*/_react.default.createElement(_shared.Container, null, sections.map(function (section, index) {
    return /*#__PURE__*/_react.default.createElement(Item, {
      key: index,
      section: section,
      pages: pages
    });
  })));
};

exports.Sections = Sections;
Sections.propTypes = {
  pages: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  sections: _propTypes.default.arrayOf(_propTypes.default.object).isRequired
};

var Item = function Item(_ref2) {
  var section = _ref2.section,
      pages = _ref2.pages;
  var pagesById = (0, _react.useMemo)(function () {
    return (0, _shared.arrayToObject)(pages);
  }, [pages]);
  var id = (0, _shared.getProperty)(section, "id");
  var teaser = (0, _shared.getProperty)(section, "teaser");
  var title = (0, _shared.getProperty)(section, "title");
  var text = (0, _shared.getProperty)(section, "text");
  var linkId = (0, _shared.getProperty)(section, "link.0.id");
  var linkText = (0, _shared.getProperty)(section, "linkText");
  var imageTitle = (0, _shared.getProperty)(section, "imageTitle");
  var imageCaption = (0, _shared.getProperty)(section, "imageCaption");
  var linkUrl = (0, _shared.getProperty)(section, "linkUrl");
  var linkPath = (0, _shared.getProperty)(pagesById, "".concat(linkId, ".data.path"));
  var mapImages = (0, _react.useCallback)(function (property) {
    var images = (0, _shared.getProperty)(section, property) || [];
    return images.map(function (image) {
      return (0, _shared.getProperty)(image, "localFile");
    });
  }, [section]);
  var slides = (0, _react.useMemo)(function () {
    return mapImages("slides");
  }, [mapImages]);
  var images = (0, _react.useMemo)(function () {
    return mapImages("images");
  }, [mapImages]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: _sectionsModule.default.item
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.content
  }, teaser && /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.teaser
  }, /*#__PURE__*/_react.default.createElement(_shared.Text, {
    type: "special",
    color: "primary",
    transform: "uppercase",
    size: "xl",
    weight: "bold"
  }, teaser)), /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.title
  }, /*#__PURE__*/_react.default.createElement(_shared.Title, null, title)), /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.text
  }, /*#__PURE__*/_react.default.createElement(_shared.Text, {
    newLineToBreak: true
  }, text)), linkPath && /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.link
  }, /*#__PURE__*/_react.default.createElement(_shared.Button, {
    wrapper: _gatsby.Link,
    to: linkPath
  }, linkText)), linkUrl && /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.link
  }, /*#__PURE__*/_react.default.createElement(_shared.Button, {
    wrapper: "a",
    href: linkUrl,
    rel: "noopener noreferrer"
  }, linkText))), /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.images
  }, /*#__PURE__*/_react.default.createElement(_shared.ImageSlider, {
    slides: slides,
    images: images,
    dots: false
  }), imageTitle && imageCaption && /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.imageMeta
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.imageTitle
  }, /*#__PURE__*/_react.default.createElement(_shared.Title, {
    wrapper: "h3",
    color: "white"
  }, imageTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionsModule.default.imageCaption
  }, /*#__PURE__*/_react.default.createElement(_shared.Title, {
    wrapper: "h4",
    color: "white"
  }, imageCaption)))));
};

Item.propTypes = {
  section: _propTypes.default.object.isRequired,
  pages: _propTypes.default.arrayOf(_propTypes.default.object.isRequired).isRequired
};